import { render, staticRenderFns } from "./testMembership.vue?vue&type=template&id=0c9884e6&scoped=true&"
import script from "./testMembership.vue?vue&type=script&lang=js&"
export * from "./testMembership.vue?vue&type=script&lang=js&"
import style0 from "./testMembership.vue?vue&type=style&index=0&id=0c9884e6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c9884e6",
  null
  
)

export default component.exports